import { Center, Loader, Stack, Text } from '@mantine/core';
import { useMatch } from '@tanstack/react-location';
import { LocationGenerics } from '../../routes/types/routing.types';
import { useOnlineSchedulerDigitalForm } from './api/REST/useOnlineSchedulerDigitalForm';
import { OnlineSchedulerSurveyFormWrapper } from './form/components/OnlineSchedulerSurveyFormWrapper';

export const OnlineSchedulerDigitalFormsMain = () => {
  const { params } = useMatch<LocationGenerics>();
  const { uuid } = params;
  const { data, isLoading } = useOnlineSchedulerDigitalForm({ opcode: 'osDfRn1NdrR2nDr5' }, { uuid });

  if (isLoading) {
    return (
      <main role="main" aria-labelledby="form-title">
        <Center aria-live="polite" role="status">
          <Loader color="gray" size="lg" type="bars" aria-label="Loading digital form" />
          <span className="visually-hidden">Loading, please wait.</span>
        </Center>
      </main>
    );
  }

  if (!data || !('uuid' in data) || !data.uuid) {
    return (
      <main role="main" aria-labelledby="form-title">
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
          }}
        >
          <div
            style={{
              padding: '3rem',
              borderRadius: '12px',
              background: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              textAlign: 'center',
              maxWidth: '400px',
            }}
          >
            <Text size="lg" style={{ color: '#495057' }}>
              Form not found or has already been completed.
            </Text>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main role="main" aria-labelledby="form-title">
      <Stack role="region" aria-label="Digital form" style={{}}>
        <OnlineSchedulerSurveyFormWrapper form={data} />
      </Stack>
    </main>
  );
};
